<template>
  <section class="boss-skill-sheet">
    <table class="unstriped boss-table">
      <thead>
        <tr>
          <th class="boss-table-head">
            コメント
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="boss-table-data">
            <textarea
              v-model="comment"
              class="boss-send-textarea pega-textarea-resize-none"
              data-test="comment"
            />
          </td>
        </tr>
      </tbody>
    </table>
    <!-- ▼コメントを更新ボタン -->
    <div class="boss-layout boss-layout-center">
      <button
        class="boss-button boss-button-confirm pega-button"
        data-test="save"
        @click="save"
      >
        コメントを更新
      </button>
    </div>
    <!-- ▲コメントを更新ボタン -->
  </section>
</template>

<script>
import Indicator from '@/lib/indicator'

export default {
  props: {
    userId: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      comment: ''
    }
  },
  computed: {
    isOverLength () {
      return this.comment.length > 200
    }
  },
  created () {
    this.fetch().then(response => {
      this.comment = response.data
    })
  },
  methods: {
    fetch () {
      return this.$http.secured.get(`/scout/view/users/${this.userId}/_comment`)
    },
    save () {
      Indicator.emitShow()
      this.$http.secured.put(`/scout/view/users/${this.userId}/_comment`, { comment: this.comment })
        .then(_ => {
          this.$toasted.global.success({ message: 'コメントを更新しました。' })
          this.$emit('update-comment', this.comment)
        }).finally(() => {
          Indicator.emitHide()
        })
    }
  }
}
</script>
